import React from 'react';
import {Table, Column, Cell} from 'fixed-data-table';
import "fixed-data-table/dist/fixed-data-table.css";
import {connect} from 'react-redux';
import moment from 'moment';
import Select from 'react-select';
import { push } from 'react-router-redux';
import api from 'api';
import { findDOMNode } from 'react-dom';
import * as ClientActions from '../actions/ClientActions';
import SearchInput from '../components/SearchInput';
import PaginationLinks from '../components/paginator/PaginationLinks';
import {isToday} from '../utils/datehelpers';
import StaffMemberPicker from '../components/StaffMemberPicker';
import CountrySelect from '../components/CountrySelect';
import CitySelect from '../components/CitySelect';
import StateSelect from '../components/StateSelect';
import {Dropdown, DropdownItem} from '../components/bootstrap/Dropdown';
import ClientPreview from '../components/clients/ClientPreview';
import TagSelect from '../components/checked-select/CheckedSelect';
import clientStages, {getStageFromId} from '../constants/clientStages';
import ProgressBar from './progress-bar/ProgressBar';

var nextContactDateOptions = [
    {
        value: 'Never',
        label: 'No follow up'
    }
];

@connect(
    state => ({
        columns: state.clients.columns,
        filters: state.clients.filters
    }),
    ClientActions
)
class ColumnsDropdown extends React.Component {
    changeColumnFixed(columnId) {
        this.props.toggleClientsTableColumnFixed(columnId);
    }
    changeColumnVisible(columnId) {
        this.props.toggleClientsTableColumnVisible(columnId);
    }
    changeFilterVisible(lookupKey) {
        this.props.toggleFilterVisible(lookupKey);
    }
    render() {
        return (
            <Dropdown iconName="cog" className="col-xs-2" stayOpenOnClickInside={true} dropdownStyle={{width: '190px'}}>
                <li className="dropdown-header" key="settingsHeader">Column Settings</li>
                {this.props.columns.map(c => {
                    var fixedStyle = {marginTop: '4px'};
                    var toggleStyle = {marginRight: '12px'};
                    return (
                        <DropdownItem key={c.title} onClick={this.changeColumnVisible.bind(this, c.id)}>
                            {c.isVisible &&
                            <i style={toggleStyle} className="fa fa-toggle-on"></i>
                            }
                            {!c.isVisible &&
                            <i style={toggleStyle} className="fa fa-toggle-off"></i>
                            }
                            <span>{c.title}</span>
                            {c.isVisible && c.isFixed &&
                            <i style={fixedStyle} className="fa fa-lock hover-pointer pull-right" title="Column remains fixed on the left when you scroll editor" onClick={this.changeColumnFixed.bind(this, c.id)}></i>
                            }
                            {c.isVisible && ! c.isFixed &&
                            <i style={fixedStyle} className="fa fa-unlock-alt hover-pointer muted pull-right"title="Lock column on the left" onClick={this.changeColumnFixed.bind(this)}></i>
                            }
                        </DropdownItem>
                    );
                })}
                <hr />
                <li className="dropdown-header" key="filtersHeader">Visible Filters</li>
                {this.props.filters.map(f => {
                    var toggleStyle = {marginRight: '12px'};
                    return (
                        <DropdownItem key={f.title} onClick={this.changeFilterVisible.bind(this, f.lookupKey)}>
                            {f.isVisible &&
                            <i style={toggleStyle} className="fa fa-toggle-on"></i>
                            }
                            {!f.isVisible &&
                            <i style={toggleStyle} className="fa fa-toggle-off"></i>
                            }
                            <span>{f.title}</span>
                        </DropdownItem>
                    );
                })}
            </Dropdown>
        );
    }
}

var getDate = (date) => {
    if(! date) {
        return null;
    }

    return isToday(date) ? "Today" : moment(date).format('MMM D, YYYY');
};

var isCorrectStaffCount = (staffCount) => {
    return staffCount > 1 && staffCount <= 20;
};

@connect(
    state => ({
        isLoaded: state.clients.loaded,
        isLoading: state.clients.loading,
        clients: state.clients.clients,
        filters: state.clients.filters,
        paginationData: state.clients.paginationData,
        searchText: state.clients.searchText,
        columns: state.clients.columns,
        isColumnResizing: state.clients.isColumnResizing,
        authUser: state.auth.user,
        isSideBarOpen: state.sidebar.isOpen
    }),
    {push, ...ClientActions}
)
export default class ClientsFixedDataTable extends React.Component {
    constructor(props) {
        super(props);

        var lastSearch = JSON.parse(localStorage.getItem('lastClientSearch'));

        var getInitialAssignedIds = (props) => {
            if(! lastSearch) {
                return [props.authUser.id];
            }

            return lastSearch.assignedUserIds;
        };

        this.tags = [];

        this.state = {
            country: lastSearch ? lastSearch.country : null,
            city: lastSearch ? lastSearch.city : '',
            state: lastSearch ? lastSearch.state : '',
            searchText: lastSearch ? lastSearch.searchText : '',
            assignedUserIds: getInitialAssignedIds(props),
            isColumnsDropdownOpen: false,
            nextContactDate: null,
            staffCount: null,
            hidePayingUsers: false,
            showDuds: false,
            perPage: 50,
            tagsSelected: [],
            clientStageId: null,
            width: this.props.mainWidth ? this.props.mainWidth - 30 : 800
        };
        this.makeColumn = this.makeColumn.bind(this);
        this.makeSearchQuery = this.makeSearchQuery.bind(this);
        this.updateWidthFromParent = this.updateWidthFromParent.bind(this);
    }

    async componentDidMount() {
        // set the default search if there is some
        if (this.props.defaultSearch){
            this.props.searchClients(
                this.makeSearchQuery(this.props.defaultSearch)
            );
            if (this.props.defaultSearch.orderByID){
                this.props.changeClientSortOrder(this.props.defaultSearch.orderByID, this.props.defaultSearch.sortDir);
            }
            this.setState({...this.props.defaultSearch});
        }

        window.addEventListener('resize', this.updateWidthFromParent);
        this.updateWidthFromParent();

        api.get('tags').then(r => {
            this.tags = r.value;
        });
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.isSideBarOpen != this.props.isSideBarOpen) {
            setTimeout(() => {
                this.updateWidthFromParent();
            }, 800);            
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidthFromParent);
    }

    updateWidthFromParent(){
        var node = findDOMNode(this);

        //don't force a rerender if it isn't needed
        if(node.clientWidth !== this.state.width)
            this.setState({ width: node.clientWidth });
    }

    _onRowSelect(e, index) {        
        var client = this.props.clients[index];
        
        if(e.ctrlKey || e.metaKey) {
            window.open(`/clients/${client.id}`);
        } else {
            this.props.push(`/clients/${client.id}`);
        }
    }

    makeColumn(column, i) {
        
        var changeSortDir = (e) => {
            if(column.isSortable) {
                var getNewSortOrder = (currentDir) => {
                    if(! currentDir) {
                        return 'ASC';
                    }
                    if(currentDir === 'DESC') return 'ASC';
                    return 'DESC';
                };

                var sortDir = getNewSortOrder(column.sortDir);

                this.props.changeClientSortOrder(column.id, sortDir);

                this.setState({
                    orderByColumn : column.lookupKey,
                    sortDir : sortDir
                });

                this.props.searchClients(
                    this.makeSearchQuery({
                        orderBy: {
                            column: column.lookupKey,
                            direction: sortDir
                        }
                    })
                );
            }
        };

        var getSortClass = () => {
            if(! column.isSortable) return '';            
            if(this.props.sortDir == 'ASC') return 'sorting_asc';
            return 'sorting_desc';
        };

        var Header = (
            <Cell>
              <div className={`column-header ${getSortClass()}`} onClick={changeSortDir}>
                  <span>{column.title}</span> {column.sortDir && <i className={`fa fa-sort-${column.sortDir.toLowerCase()}`}></i>}
              </div>
            </Cell>
        );

        var BodyCell = ({rowIndex, field, data, ...props}) => {            
            //<div style={{overflow : 'hidden', textOverflow : 'ellipsis', maxWidth : column.width - 12, whiteSpace : 'nowrap'}}></div>
            return (
            <Cell {...props}>                
                {data[rowIndex][field]}                
            </Cell>
            )
        };

        var AssignedUserCell = ({rowIndex, field, data, ...props}) => {            
            var assignedUser = data[rowIndex][field];
            var assignedUserText = assignedUser ? `${assignedUser.firstName} ${assignedUser.lastName}` : null;

            return (
              <Cell {...props}>
                <span>{assignedUserText}</span>
              </Cell>
            );
        };

        var DateCell = ({rowIndex, field, data, ...props}) => (
            <Cell {...props}>
              <span>{getDate(data[rowIndex][field])}</span>
            </Cell>
        );

        var NameCell = ({rowIndex, field, data, ...props}) => {
            var staffCount = data[rowIndex]['reportedStaffCount'];
            var correctStaffCount = isCorrectStaffCount(staffCount);
            var isOMB = staffCount == 1;
            var overStaffed = staffCount > 20;

            var style = data[rowIndex].status == "Dud" ? {color: 'red'} : {};

            return (
                <Cell {...props}>
                  <span style={style} className={! correctStaffCount ? 'outsideStaff' : ''}>
                    { isOMB && 
                        <i style={{marginRight : '5px'}} className="fa fa-male"></i>
                    }
                    { overStaffed && 
                        <i style={{marginRight : '5px'}} className="fa fa-users"></i>
                    }
                    {data[rowIndex][field]}
                  </span>
                </Cell>
            )
        };

        var ReportedStaffCountCell = ({rowIndex, field, data, ...props}) => {
            var staffCount = data[rowIndex][field];
            var color = isCorrectStaffCount(staffCount) ? {} : {color : 'red'};
            return (
                <Cell {...props}>
                    <span style={color}>{staffCount}</span>
                </Cell>
            );
        };            

        var NextFollowUpDateCell = ({rowIndex, field, data, ...props}) => {            
            var nextFollowUpDate = data[rowIndex][field];
            var staffCount = data[rowIndex]['reportedStaffCount'];

            var nextFollowUpDateText = ! nextFollowUpDate ? "Never" : moment(nextFollowUpDate).format('MMM D, YYYY');
            var color = (nextFollowUpDateText == "Never" && isCorrectStaffCount(staffCount)) ? {color : 'red'} : {};

            return (
              <Cell {...props}>
                <span style={color}>{nextFollowUpDateText}</span>
              </Cell>
            );
        };

        var TagsCell = ({rowIndex, data, ...props}) => {
            var tags = data[rowIndex].tags;

            return (
                <Cell {...props}>
                    {tags.map(tag =>
                        <span key={tag.id} className="label label-success">{tag.name}</span>
                    )}
                </Cell>
            );
        };

        var makeBodyCell = (column) => {
            if(column.lookupKey == 'assignedUser') {
                return (<AssignedUserCell data={this.props.clients} field={column.lookupKey} />);
            } 

            if(column.lookupKey == 'signedUpAt') {
                return (<DateCell data={this.props.clients} field={column.lookupKey} />);
            }

            if(column.lookupKey == 'convertedAt') {
                return (<DateCell data={this.props.clients} field={column.lookupKey} />);
            }

            if(column.lookupKey == 'trialExpiresAt') {
                return (<DateCell data={this.props.clients} field={column.lookupKey} />);
            }

            if(column.lookupKey == 'nextFollowUpDate') {
                return (<NextFollowUpDateCell data={this.props.clients} field={column.lookupKey} />);   
            }

            if (column.lookupKey == 'reportedStaffCount'){
                return (<ReportedStaffCountCell data={this.props.clients} field={column.lookupKey} />);
            }

            if (column.lookupKey == 'name'){
                return (<NameCell data={this.props.clients} field={column.lookupKey} />);                
            }

            if (column.lookupKey == 'tags'){
                return (<TagsCell data={this.props.clients} field={column.lookupKey} />);
            }

            return (<BodyCell data={this.props.clients} field={column.lookupKey} />);
        };

        return (
            <Column
                key={column.lookupKey}
                columnKey={column.lookupKey}
                width={column.width}
                isResizable={column.isResizable}
                fixed={column.isFixed}
                header={Header}
                cell={makeBodyCell(column)} />
        );
    }
    handlePageRequested(pageRequested) {
        this.props.searchClients(
            this.makeSearchQuery({
                page: pageRequested
            })
        );
    }
    handleOnSearch(searchText) {
        this.props.searchClients(this.makeSearchQuery({searchText}));
        this.setState({searchText});
    }
    handleUserIdsChanged(data) {
        const assignedUserIds = data ? data.map(d => d.value) : []
        this.props.searchClients(
            this.makeSearchQuery({assignedUserIds})
        );
        this.setState({assignedUserIds});
    }
    makeSearchQuery(queryToMerge) {
        var state = this.state;
        var searchQuery = {
            ...state,
            page: 1,
            ...queryToMerge
        };        

        if (typeof queryToMerge.orderBy == 'undefined' && this.state.orderByColumn){
            searchQuery.orderBy = {
                column: this.state.orderByColumn,
                direction: this.state.sortDir
            }
        }

        if (this.props.handleFilterChange){
            this.props.handleFilterChange(searchQuery);
        }        

        return searchQuery;
    }
    handleCountryFilter(data) {
        const country = data ? data.value : null
        this.props.searchClients(this.makeSearchQuery({country}));
        this.setState({country});
    }
    handleCityFilter(data) {
        const city = data ? data.value : null
        this.props.searchClients(this.makeSearchQuery({city}));
        this.setState({city});
    }
    handleNextContactDate(data) {
        const nextContactDate = data ? data.value : null
        this.props.searchClients(this.makeSearchQuery({nextContactDate}));
        this.setState({nextContactDate});
    }
    toggleHideOneMan() {
        var hideOneManBands = ! this.state.hideOneManBands;
        this.props.searchClients(this.makeSearchQuery({hideOneManBands}));
        this.setState({hideOneManBands});
    }
    toggleShowActiveLessThanReported() {
        var showActiveLessThanReported = ! this.state.showActiveLessThanReported;
        this.props.searchClients(this.makeSearchQuery({showActiveLessThanReported}));
        this.setState({showActiveLessThanReported});
    }
    toggleHidePayingUsers() {
        var hidePayingUsers = ! this.state.hidePayingUsers;
        this.props.searchClients(this.makeSearchQuery({hidePayingUsers}));
        this.setState({hidePayingUsers});
    }
    toggleShowDuds() {
        var showDuds = ! this.state.showDuds;
        this.props.searchClients(this.makeSearchQuery({showDuds}));
        this.setState({showDuds});
    }
    shouldShowFilter(filterName) {
        return ! this.props.hideAllFilters && this.props.filters.find(f => f.lookupKey == filterName).isVisible;
    }
    handleStateFilter(state) {
        this.props.searchClients(this.makeSearchQuery({state}));
        this.setState({state});
    }
    handleClientStageFilter(data) {
        const clientStageId = data ? data.value : null
        this.props.searchClients(this.makeSearchQuery({clientStageId}));
        this.setState({clientStageId});
    }
    changePerPage({target}) {
        var perPage = target.value;
        this.props.searchClients(this.makeSearchQuery({perPage}));
        this.setState({perPage});
    }
    changeTagsSelected(tagsSelected) {
        this.props.searchClients(this.makeSearchQuery({tagsSelected}));
        this.setState({tagsSelected});
    }
    render() {
        var editorWidth = this.props.mainWidth ? this.props.mainWidth - 30 : this.state.width;
        //var editorWidth = this.state.width;

        var {tagsSelected} = this.state;

        // Temporarily disable touch screen interface for this view as we want to move it to be a setting rather than dynamic based on the client
        var isTouch = false; // 'ontouchstart' in document.documentElement || 'onmsgesturechange' in window;

        var baseBaseFilterElementStyle = {
            display: 'flex',
            marginLeft: 5,
            marginRight: 5,
            marginBottom: 5,
            flex: 1,
        }

        var baseFilterElementStyle = {
            ...baseBaseFilterElementStyle,
            flexBasis: '145px'
        };

        var userAssignedWidth = Math.max(180, this.state.assignedUserIds.length * 160);

        var clientStageOptions = clientStages.map(stage => {
            return { value: stage.id, label: stage.name };
        });

        return (
            <div id="editor-wrapper" ref={el => this.editorWrapper = el}>
                {this.props.isLoading &&
                    <ProgressBar top={93} />
                }
                <div>
                    <div className="panel panel-default" style={{marginBottom: '0px'}}>
                        <div className="panel-body" style={{backgroundImage: 'linear-gradient(#fff, #f7f8fb)', borderBottom: 'none', padding: '7px'}}>
                            <div id="client-search-filters" style={{display: 'flex', flexWrap: 'wrap'}}>
                                {this.shouldShowFilter('tags') &&
                                    <div style={{...baseFilterElementStyle}}>
                                        <TagSelect
                                            onChange={this.changeTagsSelected.bind(this)}
                                            tags={this.tags}
                                            tagsSelected={tagsSelected} />
                                    </div>
                                }
                                {this.shouldShowFilter('clientStage') &&
                                    <div style={baseFilterElementStyle}>
                                        <div style={{flex: 1}}>
                                            <Select
                                                style={{flex: 1}}
                                                height={10}
                                                placeholder="Stage"
                                                options={clientStageOptions}
                                                value={getStageFromId(this.state.clientStageId)}
                                                onChange={this.handleClientStageFilter.bind(this)}/>
                                        </div>
                                    </div>
                                }
                                {this.shouldShowFilter('search') &&
                                    <div style={baseFilterElementStyle}>
                                        <SearchInput
                                            searchText={this.state.searchText}
                                            placeholder="Search Clients"
                                            onSearch={this.handleOnSearch.bind(this)} />
                                    </div>
                                }
                                {this.shouldShowFilter('assignedUser') && this.props.authUser.isFg &&
                                    <div style={{minWidth: userAssignedWidth, ...baseBaseFilterElementStyle}}>
                                        <StaffMemberPicker
                                            style={{flex: 1}}
                                            selectPlaceHolder={"Staff member"}
                                            onSelectChange={this.handleUserIdsChanged.bind(this)}
                                            onlyOneAssign={false}
                                            includeAvatarPicker={false}
                                            assignedUserIds={this.state.assignedUserIds}/>
                                    </div>
                                }
                                {this.shouldShowFilter('followUp') &&
                                    <div style={baseFilterElementStyle}>
                                        <div style={{flex: 1}}>
                                            <Select
                                                style={{flex: 1}}
                                                height={10}
                                                placeholder="Follow Up"
                                                options={nextContactDateOptions}
                                                value={this.state.nextContactDate}
                                                onChange={this.handleNextContactDate.bind(this)}/>
                                        </div>
                                    </div>
                                } 
                                {this.shouldShowFilter('city') &&
                                    <div style={baseFilterElementStyle}>
                                        <div style={{flex: 1}}>
                                            <CitySelect city={this.state.city} onChange={this.handleCityFilter.bind(this)}/>
                                        </div>
                                    </div>
                                }
                                {this.shouldShowFilter('state') &&
                                <div style={baseFilterElementStyle}>
                                    <div style={{flex: 1}}>
                                        <StateSelect state={this.state.state} onChange={this.handleStateFilter.bind(this)}/>
                                    </div>
                                </div>
                                }
                                {this.shouldShowFilter('country') &&
                                    <div style={baseFilterElementStyle}>
                                        <div style={{flex: 1}}>
                                            <CountrySelect country={this.state.country}
                                                       onChange={this.handleCountryFilter.bind(this)}/>
                                        </div>
                                    </div>
                                }
                                {this.shouldShowFilter('hideOneManBands') &&
                                    <button
                                        style={{marginLeft: 5, marginRight: 5}}
                                        id="hide-1-man-bands"
                                        onClick={this.toggleHideOneMan.bind(this)}
                                        className={"btn"}>
                                        <i className={"fa " + (this.state.hideOneManBands ? "fa-check-circle" : "fa-square-o")}></i> Hide one man bands
                                    </button>
                                }
                                {this.shouldShowFilter('showActiveLessThanReported') &&
                                    <button
                                        style={{marginLeft: 5, marginRight: 5}}
                                        id="show-active-less-than-reported"
                                        onClick={this.toggleShowActiveLessThanReported.bind(this)}
                                        className={"btn"}>
                                        <i className={"fa " + (this.state.showActiveLessThanReported ? "fa-check-circle" : "fa-square-o")}></i> Show Active &lt; Reported Staff
                                    </button>
                                }
                                {this.shouldShowFilter('hidePayingUsers') &&
                                <button
                                    style={{marginLeft: 5, marginRight: 5}}
                                    id="hide-1-paying-users"
                                    onClick={this.toggleHidePayingUsers.bind(this)}
                                    className={"btn"}>
                                    <i className={"fa " + (this.state.hidePayingUsers ? "fa-check-circle" : "fa-square-o")}></i> Hide paying users                                    
                                </button>
                                }
                                {this.shouldShowFilter('showDuds') &&
                                <button
                                    style={{marginLeft: 5, marginRight: 5}}
                                    id="hide-1-duds"
                                    onClick={this.toggleShowDuds.bind(this)}
                                    className={"btn"}>                                    
                                    <i className={"fa " + (this.state.showDuds ? "fa-square-o" : "fa-check-circle" )}></i> Hide duds
                                </button>
                                }

                                <div style={{width: 117, display: 'flex', alignItems: 'center'}}>
                                    <p style={{margin: 0}}>Per page:</p>
                                    <select onChange={this.changePerPage.bind(this)} className="form-control" style={{width: 50, marginLeft: 'auto'}}>                                        
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                    </select>
                                </div>
                                <div id="columns-dropdown-wrapper">
                                    <ColumnsDropdown />
                                </div>
                                <PaginationLinks
                                    handleNextPageRequested={this.handlePageRequested.bind(this)}
                                    numLinks={3}
                                    paginationData={this.props.paginationData} />
                            </div>
                        </div>
                    </div>
                </div>
                {!isTouch &&
                    <div style={{fontSize : '13px'}}>
                        <Table
                            maxHeight={1000}
                            width={editorWidth}
                            rowsCount={this.props.clients.length}
                            rowHeight={28}
                            groupHeaderHeight={28}
                            headerHeight={28}
                            isColumnResizing={this.props.isColumnResizing}
                            onRowClick={this._onRowSelect.bind(this)}
                            onColumnResizeEndCallback={this.props.resizeClientsTableColumn}>
                            
                            {this.props.columns.filter(c => c.isVisible).map(this.makeColumn)}
                        </Table>
                    </div>
                }
                {isTouch &&
                    <ClientsTouchView {...this.props} />
                }
                {!this.props.clients.length && this.props.isLoaded &&
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <p>No clients matched search result</p>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

var addressFromClient = c => {
    var withTrailing = [c.city, c.state, c.country]
        .filter(a => !!a)
        .filter((a, idx, arr) => arr.indexOf(a) == idx)
        .reduce((str, a) => str + a + ', ', '');

    return withTrailing.substr(0, withTrailing.length - 2);
};

window.addressFromClient = addressFromClient;


@connect(
    state => ({
        users: state.users.users
    })
)
class ClientsTouchView extends React.Component {
    render() {
        return (
            <div className="panel panel-default">
                <div className="panel-body">
                  <ul className="media-list">
                      {this.props.clients.map(c => {
                          var client = {
                              ...c,
                              activeUsers: Array(c.reportedStaffCount),
                              address: addressFromClient(c)
                          };
                          return (
                              <ClientPreview
                                  showLogo={false}
                                  key={c.id}
                                  staff={this.props.users}
                                  client={client}/>
                          )
                      })}
                  </ul>
              </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/ClientsFixedDataTable.js